var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { validateApplePayInitParams } from "../models/ApplePayInitParams";
import EventReporter from "./eventReporter/EventReporter";
import { ApplePayEventTypeEnumsObj } from "../enums/ApplePayEventTypeEnum";
import ApplePaySdkService from "./ApplePaySdkService";
import { validateApplePayButtonParams } from "../models/ApplePayButtonParams";
import { BUILD_TYPE, SDK_VERSION } from "../models/ApplePayVersion";
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk/models/BaseEcomSdkEnum";
import { getButtonLang, getValuesFromLocale } from "@payair/e-com-common-sdk/core/Helpers";
/** @internal */
var applePaySession;
/** @internal */
var applePayInitParamsGlobal;
/** @internal */
var eventReporter;
/** @internal */
var applePaySdkService;
/** @internal */
var isSdkInitialized;
/** @internal */
var localeData = null;
/** @internal */
var APPLE_PAY_SDK_SCRIPT = "https://applepay.cdn-apple.com/jsapi/v1.3.2/apple-pay-sdk.js";
/** @internal */
var ApplePaySdkImpl = /** @class */ (function () {
    function ApplePaySdkImpl() {
        var _this = this;
        this.initSdk = function (applePayInitParams) {
            isSdkInitialized = false;
            var applePayInitParamsValidationResult = validateApplePayInitParams(applePayInitParams);
            if (applePayInitParamsValidationResult.length > 0) {
                dispatchEvent(ApplePayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_INITPARAMS_NOT_DEFINED, undefined, undefined, applePayInitParamsValidationResult.join(", "));
                return;
            }
            localeData = getValuesFromLocale(applePayInitParams.locale);
            applePayInitParamsGlobal = applePayInitParams;
            eventReporter.initEventReporterService(applePayInitParamsGlobal.pspName, applePayInitParamsGlobal.transactionId, applePayInitParamsGlobal.merchantId);
            addApplePaySdkScript()
                .then(function () { return initSdkImpl(applePayInitParams); })
                .catch(function (error) { return dispatchEvent(ApplePayEventTypeEnumsObj.SDK_INITIALIZE_ERROR, undefined, undefined, error); });
        };
        this.renderButton = function (container, applePayButtonParams) {
            renderButtonImpl(container, applePayButtonParams);
        };
        this.isReadyToPay = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, isReadyToPayImpl()];
        }); }); };
        this.isUserEligibleToMakePayment = function (merchantId) { return __awaiter(_this, void 0, void 0, function () {
            var merchantIdParam;
            return __generator(this, function (_a) {
                merchantIdParam = merchantId ? merchantId : applePayInitParamsGlobal === null || applePayInitParamsGlobal === void 0 ? void 0 : applePayInitParamsGlobal.merchantId;
                if (!merchantIdParam)
                    return [2 /*return*/, Promise.reject("merchantId undefined or SDK not initialized")];
                if (!window["ApplePaySession"])
                    return [2 /*return*/, Promise.resolve(false)];
                return [2 /*return*/, ApplePaySession.canMakePaymentsWithActiveCard(merchantIdParam)];
            });
        }); };
        this.startPayment = function () { return startPaymentImpl(); };
        this.getVersion = function () {
            return {
                sdk: BaseEcomSdkEnumsObj.PAYAIR_APPLE_PAY_SDK,
                version: SDK_VERSION,
                buildType: BUILD_TYPE,
            };
        };
        eventReporter = new EventReporter();
        isSdkInitialized = false;
    }
    return ApplePaySdkImpl;
}());
export { ApplePaySdkImpl };
/** @internal */
var startPaymentImpl = function () {
    if (!isSdkInitialized || !applePayInitParamsGlobal || !applePaySdkService || !localeData) {
        dispatchEvent(ApplePayEventTypeEnumsObj.SDK_NOT_INITIALIZED);
        return;
    }
    initApplePaySession(applePayInitParamsGlobal, applePaySdkService, localeData.countryCode);
    applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.begin();
};
/** @internal */
var renderButtonImpl = function (container, applePayButtonParams) { return __awaiter(void 0, void 0, void 0, function () {
    var addApplePaySdkScriptResult, buttonContainer, applePayButtonParamsValidationResult, applePayButtonLocale, existingButton, button;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, addApplePaySdkScript()];
            case 1:
                addApplePaySdkScriptResult = _a.sent();
                if (addApplePaySdkScriptResult !== true)
                    return [2 /*return*/, Promise.reject(addApplePaySdkScriptResult)];
                if (!window["ApplePaySession"]) {
                    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_RENDER_FAIL_DEVICE_NOT_ELIGIBLE);
                    return [2 /*return*/];
                }
                buttonContainer = document.getElementById(container);
                if (!buttonContainer) {
                    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS);
                    return [2 /*return*/];
                }
                applePayButtonParamsValidationResult = validateApplePayButtonParams(applePayButtonParams);
                if (applePayButtonParamsValidationResult.length > 0) {
                    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_RENDER_ERROR, undefined, undefined, applePayButtonParamsValidationResult.join(", "));
                    return [2 /*return*/];
                }
                applePayButtonLocale = getButtonLang(applePayButtonParams, localeData, "PAYAIR_APPLE_PAY_SDK");
                if (applePayButtonLocale === null) {
                    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_RENDER_ERROR, undefined, undefined, "applePayButtonParams.buttonLocale is required when using `renderButton()` without initializing the SDK first");
                    return [2 /*return*/];
                }
                existingButton = buttonContainer.querySelector("apple-pay-button");
                if (!existingButton) {
                    button = document.createElement("apple-pay-button");
                    button.setAttribute("buttonstyle", applePayButtonParams.buttonColor);
                    button.setAttribute("type", applePayButtonParams.buttonType);
                    button.setAttribute("locale", applePayButtonLocale);
                    button.style.display = "inline-block";
                    button.onclick = function () { return applePayButtonOnClick(startPaymentImpl, applePayButtonParams.buttonOnClick); };
                    buttonContainer.appendChild(button);
                    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_RENDERED);
                    return [2 /*return*/];
                }
                dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_NOT_RENDERED_ALREADY_EXISTS);
                return [2 /*return*/];
        }
    });
}); };
/** @internal */
var addApplePaySdkScript = function () { return __awaiter(void 0, void 0, void 0, function () {
    var addGooglePaySdkScriptPromise;
    return __generator(this, function (_a) {
        addGooglePaySdkScriptPromise = new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var isScriptAdded, intervalId_1, script;
            return __generator(this, function (_a) {
                isScriptAdded = !!Array.from(document.head.childNodes).filter(function (node) { return node && node["src"] && node["src"].match(new RegExp(APPLE_PAY_SDK_SCRIPT)); }).length;
                if (isScriptAdded) {
                    intervalId_1 = setInterval(function () {
                        if (window["applePayScriptLoaded"] === true) {
                            clearInterval(intervalId_1);
                            resolve(true);
                        }
                    }, 100);
                }
                else {
                    script = document.createElement("script");
                    script.src = APPLE_PAY_SDK_SCRIPT;
                    script.async = true;
                    script.onload = function () {
                        window["applePayScriptLoaded"] = true;
                        resolve(true);
                    };
                    script.onerror = function (error) { return reject(error); };
                    document.head.appendChild(script);
                }
                return [2 /*return*/];
            });
        }); });
        return [2 /*return*/, addGooglePaySdkScriptPromise];
    });
}); };
/** @internal */
var isReadyToPayImpl = function () { return __awaiter(void 0, void 0, void 0, function () {
    var addApplePaySdkScriptResult, canMakePayments;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, addApplePaySdkScript()];
            case 1:
                addApplePaySdkScriptResult = _a.sent();
                if (addApplePaySdkScriptResult !== true)
                    return [2 /*return*/, Promise.reject(addApplePaySdkScriptResult)];
                if (!window["ApplePaySession"])
                    return [2 /*return*/, Promise.resolve(false)];
                canMakePayments = ApplePaySession.canMakePayments();
                canMakePayments
                    ? dispatchEvent(ApplePayEventTypeEnumsObj.DEVICE_READY_TO_PAY)
                    : dispatchEvent(ApplePayEventTypeEnumsObj.DEVICE_NOT_READY_TO_PAY);
                return [2 /*return*/, Promise.resolve(canMakePayments)];
        }
    });
}); };
/** @internal */
var initSdkImpl = function (applePayInitParams) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, isReadyToPayImpl().then(function (response) {
                    if (!response) {
                        dispatchEvent(ApplePayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE);
                        return;
                    }
                    applePaySdkService = new ApplePaySdkService(applePayInitParams.pspName);
                    isSdkInitialized = true;
                    dispatchEvent(ApplePayEventTypeEnumsObj.SDK_INITIALIZE_SUCCESS);
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/** @internal */
var applePayButtonOnClick = function (startPayment, userButtonOnClickFunction) {
    dispatchEvent(ApplePayEventTypeEnumsObj.BUTTON_CLICK);
    if (userButtonOnClickFunction)
        userButtonOnClickFunction();
    else
        startPayment();
};
/** @internal */
var initApplePaySession = function (applePayInitParams, applePaySdkService, countryCode) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    try {
        dispatchEvent(ApplePayEventTypeEnumsObj.WALLET_SESSION_CREATION_STARTED);
        var total = undefined;
        if ((_a = applePayInitParams.applePayPaymentRequest) === null || _a === void 0 ? void 0 : _a.total)
            total = applePayInitParams.applePayPaymentRequest.total;
        else {
            total = {
                amount: applePayInitParams.totalAmount,
                label: applePayInitParams.totalAmountLabel,
            };
        }
        var applePayPaymentRequest = {
            countryCode: countryCode,
            currencyCode: applePayInitParams.currencyCode,
            merchantCapabilities: ((_b = applePayInitParams.applePayPaymentRequest) === null || _b === void 0 ? void 0 : _b.merchantCapabilities)
                ? applePayInitParams.applePayPaymentRequest.merchantCapabilities
                : ["supports3DS"],
            lineItems: (_c = applePayInitParams.applePayPaymentRequest) === null || _c === void 0 ? void 0 : _c.lineItems,
            supportedNetworks: ((_d = applePayInitParams.applePayPaymentRequest) === null || _d === void 0 ? void 0 : _d.supportedNetworks)
                ? applePayInitParams.applePayPaymentRequest.supportedNetworks
                : ["visa", "mastercard"],
            total: total,
            billingContact: (_e = applePayInitParams.applePayPaymentRequest) === null || _e === void 0 ? void 0 : _e.billingContact,
            requiredBillingContactFields: (_f = applePayInitParams.applePayPaymentRequest) === null || _f === void 0 ? void 0 : _f.requiredBillingContactFields,
            requiredShippingContactFields: (_g = applePayInitParams.applePayPaymentRequest) === null || _g === void 0 ? void 0 : _g.requiredShippingContactFields,
            shippingContact: (_h = applePayInitParams.applePayPaymentRequest) === null || _h === void 0 ? void 0 : _h.shippingContact,
            shippingMethods: (_j = applePayInitParams.applePayPaymentRequest) === null || _j === void 0 ? void 0 : _j.shippingMethods,
            shippingType: (_k = applePayInitParams.applePayPaymentRequest) === null || _k === void 0 ? void 0 : _k.shippingType,
            shippingContactEditingMode: (_l = applePayInitParams.applePayPaymentRequest) === null || _l === void 0 ? void 0 : _l.shippingContactEditingMode,
            // TODO add handling coupons feature
            // supportsCouponCode: applePayInitParams.applePayPaymentRequest?.supportsCouponCode,
            // couponCode: applePayInitParams.applePayPaymentRequest?.couponCode,
            supportedCountries: (_m = applePayInitParams.applePayPaymentRequest) === null || _m === void 0 ? void 0 : _m.supportedCountries,
            applicationData: (_o = applePayInitParams.applePayPaymentRequest) === null || _o === void 0 ? void 0 : _o.applicationData,
        };
        applePaySession = new ApplePaySession(3, applePayPaymentRequest);
        applePaySession.onvalidatemerchant = function () { return onValidateMerchant(applePayInitParams, applePaySdkService); };
        applePaySession.onpaymentauthorized = function (event) {
            return onPaymentAuthorized(event, applePaySdkService);
        };
        // TODO add handling oncouponcodechanged
        // https://developer.apple.com/documentation/on_the_web/applepaysession/3813982-oncouponcodechanged
        applePaySession.onpaymentmethodselected = function (event) {
            return handleOnPaymentMethodSelected(event, applePayInitParams);
        };
        applePaySession.onshippingcontactselected = function (event) {
            return handleOnShippingContactSelected(event, applePayInitParams);
        };
        applePaySession.onshippingmethodselected = function (event) {
            return handleOnShippingMethodSelected(event, applePayInitParams);
        };
        applePaySession.oncancel = onCancel;
        dispatchEvent(ApplePayEventTypeEnumsObj.WALLET_SESSION_CREATED);
        return true;
    }
    catch (error) {
        console.error(error);
        dispatchEvent(ApplePayEventTypeEnumsObj.WALLET_SESSION_CREATION_FAIL, undefined, undefined, error);
        return false;
    }
};
/** @internal */
var dispatchEvent = function (eventType, requestId, sessionId, additionalInfo) {
    var eventParams = {
        eventType: eventType,
        requestId: requestId,
        sessionId: sessionId,
        additionalInfo: additionalInfo,
    };
    eventReporter.handleEvent(eventParams);
};
/** @internal */
var onValidateMerchant = function (applePayInitParams, applePaySdkService) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatchEvent(ApplePayEventTypeEnumsObj.MERCHANT_VALIDATION_STARTED);
                return [4 /*yield*/, applePaySdkService
                        .validateMerchant(applePayInitParams.merchantId, applePayInitParams.merchantName, window.location.hostname)
                        .then(function (response) {
                        var xRequestId = response.xRequestId;
                        var merchantSession = response.data;
                        if (!applePaySession)
                            throw new Error("applePaySession is undefined");
                        applePaySession.completeMerchantValidation(merchantSession);
                        dispatchEvent(ApplePayEventTypeEnumsObj.MERCHANT_VALIDATION_COMPLETE, xRequestId, merchantSession.merchantSessionIdentifier);
                    })
                        .catch(function (error) {
                        dispatchEvent(ApplePayEventTypeEnumsObj.MERCHANT_VALIDATION_ERROR, error.xRequestId, undefined, error);
                        abortSession();
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/** @internal */
var onPaymentAuthorized = function (event, applePaySdkService) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_COMPLETION_STARTED);
                if (!(applePayInitParamsGlobal === null || applePayInitParamsGlobal === void 0 ? void 0 : applePayInitParamsGlobal.transactionId))
                    throw new Error("applePayInitParams is undefined");
                console.log("onPaymentAuthorized event:", event);
                return [4 /*yield*/, applePaySdkService
                        .completePayment(event.payment, applePayInitParamsGlobal.transactionId)
                        .then(function (response) {
                        var xRequestId = response.xRequestId;
                        var paymentInfo = response.data;
                        if (!applePaySession)
                            throw new Error("applePaySession is undefined");
                        if (paymentInfo.status && paymentInfo.status === "APPROVED") {
                            applePaySession.completePayment(0);
                            dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_COMPLETION_OK, xRequestId);
                        }
                        else {
                            applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.completePayment(1);
                            dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, xRequestId);
                        }
                    })
                        .catch(function (error) {
                        dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, error.xRequestId, undefined, error);
                        abortSession();
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/** @internal */
var onCancel = function (event) {
    var eventJson = JSON.stringify(event);
    var eventTypeModified = event;
    var sessionErrorJson = (eventTypeModified === null || eventTypeModified === void 0 ? void 0 : eventTypeModified.sessionError) ? JSON.stringify(eventTypeModified.sessionError) : null;
    var additionalInfoArray = [];
    eventJson && additionalInfoArray.push(eventJson);
    sessionErrorJson && additionalInfoArray.push("sessionError: ".concat(sessionErrorJson));
    var additionalInfo = additionalInfoArray.join(", ");
    dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_SESSION_CANCELED, undefined, undefined, additionalInfo);
};
/** @internal */
var abortSession = function () {
    applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.abort();
    dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_SESSION_ABORTED_BY_SDK);
};
/** @internal */
function handleOnPaymentMethodSelected(event, applePayInitParams) {
    var _a;
    var currentTotal = undefined;
    if ((_a = applePayInitParams.applePayPaymentRequest) === null || _a === void 0 ? void 0 : _a.total)
        currentTotal = applePayInitParams.applePayPaymentRequest.total;
    else {
        currentTotal = {
            amount: applePayInitParams.totalAmount,
            label: applePayInitParams.totalAmountLabel,
        };
    }
    var applePayPaymentMethodUpdate = null;
    if (applePayInitParams && applePayInitParams.onPaymentMethodSelected) {
        var newApplePayPaymentMethodUpdate = applePayInitParams.onPaymentMethodSelected(event.paymentMethod);
        applePayPaymentMethodUpdate = {
            newLineItems: newApplePayPaymentMethodUpdate ? newApplePayPaymentMethodUpdate.newLineItems : undefined,
            newTotal: newApplePayPaymentMethodUpdate ? newApplePayPaymentMethodUpdate.newTotal : currentTotal,
        };
    }
    else {
        applePayPaymentMethodUpdate = {
            newLineItems: undefined,
            newTotal: currentTotal,
        };
    }
    applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.completePaymentMethodSelection(applePayPaymentMethodUpdate);
    dispatchEvent(ApplePayEventTypeEnumsObj.PAYMENT_METHOD_SELECTED);
}
/** @internal */
function handleOnShippingContactSelected(event, applePayInitParams) {
    var _a;
    var currentTotal = undefined;
    if ((_a = applePayInitParams.applePayPaymentRequest) === null || _a === void 0 ? void 0 : _a.total)
        currentTotal = applePayInitParams.applePayPaymentRequest.total;
    else {
        currentTotal = {
            amount: applePayInitParams.totalAmount,
            label: applePayInitParams.totalAmountLabel,
        };
    }
    var applePayShippingContactUpdate = null;
    if (applePayInitParams && applePayInitParams.onShippingContactSelected) {
        var newApplePayShippingContactUpdate = applePayInitParams.onShippingContactSelected(event.shippingContact);
        applePayShippingContactUpdate = {
            newLineItems: newApplePayShippingContactUpdate ? newApplePayShippingContactUpdate.newLineItems : undefined,
            newTotal: newApplePayShippingContactUpdate ? newApplePayShippingContactUpdate.newTotal : currentTotal,
            newShippingMethods: newApplePayShippingContactUpdate
                ? newApplePayShippingContactUpdate.newShippingMethods
                : undefined,
            errors: newApplePayShippingContactUpdate ? newApplePayShippingContactUpdate.errors : undefined,
        };
    }
    else {
        applePayShippingContactUpdate = {
            newLineItems: undefined,
            newTotal: currentTotal,
        };
    }
    applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.completeShippingContactSelection(applePayShippingContactUpdate);
    dispatchEvent(ApplePayEventTypeEnumsObj.SHIPPING_CONTACT_SELECTED);
}
/** @internal */
function handleOnShippingMethodSelected(event, applePayInitParams) {
    var _a;
    var currentTotal = undefined;
    if ((_a = applePayInitParams.applePayPaymentRequest) === null || _a === void 0 ? void 0 : _a.total)
        currentTotal = applePayInitParams.applePayPaymentRequest.total;
    else {
        currentTotal = {
            amount: applePayInitParams.totalAmount,
            label: applePayInitParams.totalAmountLabel,
        };
    }
    var applePayShippingMethodUpdate = null;
    if (applePayInitParams && applePayInitParams.onShippingMethodSelected) {
        var newApplePayShippingMethodUpdate = applePayInitParams.onShippingMethodSelected(event.shippingMethod);
        applePayShippingMethodUpdate = {
            newLineItems: newApplePayShippingMethodUpdate ? newApplePayShippingMethodUpdate.newLineItems : undefined,
            newTotal: newApplePayShippingMethodUpdate ? newApplePayShippingMethodUpdate.newTotal : currentTotal,
        };
    }
    else {
        applePayShippingMethodUpdate = {
            newLineItems: undefined,
            newTotal: currentTotal,
        };
    }
    applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.completeShippingMethodSelection(applePayShippingMethodUpdate);
    dispatchEvent(ApplePayEventTypeEnumsObj.SHIPPING_METHOD_SELECTED);
}
